// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/asset/20200624/css/uq_standard.css);"]);
exports.push([module.id, "@import url(/asset/20200624/css/identity-portal.css);"]);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
